import { AbstractPmsApiService } from "./abstract.service";
import { ChannelUpdateLog } from "../models";

/**
 * @class ChannelUpdateLogPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<ChannelUpdateLog>}
 */
export class ChannelUpdateLogPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/channel-log';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {ChannelUpdateLog}
     * @protected
     */
    newModel(attributes, ...params) {

        return new ChannelUpdateLog(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<ChannelUpdateLog>>}
     */
    get(params = {}, property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     *
     * @param {Property=} property
     * @returns {Promise.<Boolean>}
     */
    resend(property) {

        const url = this.url({
            propertyId: property.id,
        });

        return this.http
            .get(url + '/resync-updates', {
                headers: this.authHeaders,
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/channel-update-log.service.js